module.exports = __webpack_public_path__ + "static/Contextual_Metadata-0eccc0d8f99619cc9a9da470061bc010.png";